import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceBase, OrigamiResponse } from './base/service.base';
import { TopicField } from '@app/origami-api/utils/topic-utils';

export namespace SponsorServiceModel {
  export interface Sponsor {
    ApiName: string;
    Description: string;
    DisplayName: string;
    GroupId: number;
    GroupMembers: any; // TODO typing
    GroupTypeId: number;
    ParentGroupId: number;
    ParentTopicId: number;
    SiteId: number;
    TopicFields: TopicField[];
    TopicId: number;
    TopicName: string;
    TopicTypeId: number;
    _DedicatedPleaseReviewSettings: any; // TODO typing
  }
}

@Injectable()
export class SponsorService extends ServiceBase {
  serviceUrl = 'SponsorService.svc';

  getSponsor(sponsorTopicId: number, ...params): Observable<OrigamiResponse<SponsorServiceModel.Sponsor>> {
    return this.origamiPost('/GetSponsor', { sponsorTopicId }, ...params);
  }
}
